// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"24f92c35","197":"1f006767","496":"3b0e6080","634":"8bd116cb","727":"2b577668","818":"e363bff4","950":"7fa6fa97"}[chunkId] + ".chunk.js";
};